exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".detail-dialog[data-v-d599c954]  .el-loading-mask{background:rgba(26,68,71,.6784313725)!important}.detail-dialog[data-v-d599c954]  .el-input .el-input__inner{height:28px!important;line-height:28px!important;width:250px!important}.detail-dialog .position-wrap[data-v-d599c954]  .el-input{width:80px!important}.detail-dialog .position-wrap[data-v-d599c954]  .el-input .el-input__inner{width:100%!important;padding:0 5px!important}", ""]);

// exports
